module.exports = __webpack_public_path__ + "static/img/background.d6b1cf3c.svg";